@let schedule = loadedSchedule();
<div class="toolbar">
  <a matButton="text" [href]="'ratings/projectList'">
    <span>
      <mat-icon class="size-16">arrow_back</mat-icon>
      <label class="buttonLabel">Back to List</label>
    </span>
  </a>
  <button matButton="text" (click)="addQuickRatingLine()">
    <span>
      <mat-icon class="size-16">add</mat-icon>
      <label class="buttonLabel">Add Quick Rating</label>
    </span>
  </button>
  <button matButton="text" (click)="openSelectionTool()">
    <span>
      <mat-icon class="size-16">construction</mat-icon>
      <label class="buttonLabel">Add With Selection Tool</label>
    </span>
  </button>
  <button matButton="text" class="toolbarButton" [disabled]="isBusy()" (click)="openWorkingUnitSelectionDialog()">
    <span>
      <mat-icon class="size-16">add</mat-icon>
      <label class="buttonLabel">Add From Working List</label>
    </span>
  </button>
  <a matButton="text" [href]="'documents/SCHEDULE/' + id() + '/0'">
    <span>
      <mat-icon class="size-16">content_copy</mat-icon>
      <label class="buttonLabel">Schedule Documents</label>
    </span>
  </a>
  @if ((scheduleLines.data?.length || 0) > 1) {
    <button matButton="text" class="toolbarButton" [disabled]="isBusy()"
      (click)="openMassUpdateDialog()">
      <span>
        <mat-icon class="size-16">done_all</mat-icon>
        <label class="buttonLabel">Mass Update</label>
      </span>
    </button>
  }
  <span class="spacer"></span>
  <a matButton="text" [href]="'ratings/documentation'">
    <span>
      <mat-icon class="size-16">article</mat-icon>
      <label class="buttonLabel">Documentation</label>
    </span>
  </a>
  @if ((requestedQuoteId()?.trim()?.length || 0) === 0) {
    <button matButton="text" (click)="requestQuote()">
      <span>
        <mat-icon class="size-16">done</mat-icon>
        <label class="buttonLabel">Create Rep Quote</label>
      </span>
    </button>
  }
  @if (!isOutsideEngineer()) {
    <button matButton="text" (click)="shareWithEngineer()">
      <span>
        <mat-icon class="size-16">share</mat-icon>
        <label class="buttonLabel">Share With Engineer</label>
      </span>
    </button>
  }
</div>
@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}
<div class="content">
  <div class="tableHeader">
    <mat-form-field class="inputField">
      <mat-label>Project Name</mat-label>
      <input #projectNameInput maxlength="30" matInput [(ngModel)]="schedule.projectName"/>
      <mat-hint align="end">{{ projectNameInput.value.length }} / 30</mat-hint>
    </mat-form-field>
    <mat-form-field class="inputField">
      <mat-label>Location City</mat-label>
      <input #locationCityInput maxlength="50" matInput [(ngModel)]="schedule.overrideShipToCityName"/>
      <mat-hint align="end">{{ locationCityInput.value.length }} / 50</mat-hint>
    </mat-form-field>
    <mat-form-field class="inputField">
      <mat-label>Location State</mat-label>
      <input #locationStateInput maxlength="4" matInput [(ngModel)]="schedule.overrideShipToStateCode"/>
      <mat-hint align="end">{{ locationStateInput.value.length }} / 4</mat-hint>
    </mat-form-field>
    <mat-form-field class="inputField">
      <mat-label>Location Zip</mat-label>
      <input #locationPostalCodeInput maxlength="20" matInput [(ngModel)]="schedule.overrideShipToPostalCode"/>
      <mat-hint align="end">{{ locationPostalCodeInput.value.length }} / 20</mat-hint>
    </mat-form-field>
  </div>
  <div class="tableHeader">
    <mat-form-field class="notesField">
      <mat-label>Notes</mat-label>
      <input maxlength="200" matInput [(ngModel)]="schedule.externalNotes"/>
    </mat-form-field>
    <button matButton="elevated" class="inputButton primary-button" (click)="updateSchedule()"
      [disabled]="isBusy() || (schedule?.projectName?.length || 0) === 0">
      <span>
        <mat-icon class="size-16">save</mat-icon>
        <label class="buttonLabel">Save</label>
      </span>
    </button>
  </div>
  <div class="tableHeader">
    @if (isSureFlowUnitPresent()) {
      <button matButton="elevated" class="sureflowLoopButton"
        (click)="openSureFlowLoopSimulator()">SureFlow® Loops
      </button>
    }
  </div>
  <div class="tableHeader">
    <span class="informational">
      <label class="displayLabel">Rep Office Name:</label>
      <label class="displayValue">{{ controllingOrgName() }}</label>
    </span>
    <span class="informational">
      <label class="displayLabel">Rep Office Phone:</label>
      <label class="displayValue">{{ controllingOrgPhone() }}</label>
    </span>
    <span class="informational">
      <label class="displayLabel">Rep Quote:</label>
      <label
      class="displayValue">{{ (requestedQuoteId()?.trim()?.length || 0) === 0 || 'None' === requestedQuoteId() ? 'Not Created' : 'Created' }}</label>
    </span>
    <span class="informational">
      <label class="displayLabel">Total Qty:</label>
      <label class="displayValue">{{ totalUnitCount() }}</label>
    </span>
    <span class="spacer"></span>
    <mat-paginator [pageSizeOptions]="[25, 50, 100]" [pageSize]="25" [showFirstLastButtons]=true></mat-paginator>
  </div>
  <div class="tableWrapper">
    <table mat-table [dataSource]="scheduleLines" matSort class="paginatedTable bordered-table">
      <ng-container matColumnDef="modify">
        <th mat-header-cell *matHeaderCellDef>Edit</th>
        <td mat-cell *matCellDef="let record" class="buttonCell">
          @if (!isSureFlowUnit(record)) {
            <button matButton="text" class="tableCellButton" (click)="editLine(record)">
              <mat-icon class="size-16">edit</mat-icon>
            </button>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="copy">
        <th mat-header-cell *matHeaderCellDef>Copy</th>
        <td mat-cell *matCellDef="let record" class="buttonCell">
          @if (!isSureFlowUnit(record)) {
            <button matButton="text" class="tableCellButton" (click)="copyLine(record)">
              <mat-icon class="size-16">content_copy</mat-icon>
            </button>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="delete">
        <th mat-header-cell *matHeaderCellDef>Delete</th>
        <td mat-cell *matCellDef="let record" class="buttonCell">
          @if (!isSureFlowUnit(record)) {
            <button matButton="text" class="tableCellButton" (click)="deleteLine(record)">
              <mat-icon class="size-16">delete</mat-icon>
            </button>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="lineId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="lineId">Line ID</th>
        <td mat-cell *matCellDef="let record">{{ record.lineId }}</td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="description">Description</th>
        <td mat-cell *matCellDef="let record">{{ record.description }}</td>
      </ng-container>
      <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="quantity">Quantity</th>
        <td mat-cell *matCellDef="let record">{{ record.quantity }}</td>
      </ng-container>
      <ng-container matColumnDef="tags">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="tags">Tags</th>
        <td mat-cell *matCellDef="let record">{{ record.tags }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayColumns()"></tr>
      <tr mat-row *matRowDef="let row; columns: displayColumns();" [class.errorUnit]="isInvalidLine(row)"></tr>
    </table>
  </div>
</div>
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait</label>
    </div>
  </div>
}
